/*

  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign

  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page

  Example:
  window.location.origin/products/alex-twill-pant-mariner

*/
(function(){

	"use strict";

	/* In case you want to output a bunch of things to the debug console */
	var debug = false;
	var cartCookie;

  var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');
	if(shippingCalcExist) return;

	/* The ID of the element that you want to add the shipping fields into */
  var productSection = document.querySelector('.shopping-calculator');
	if(!productSection){ log('Could not find the element'); return }

	/* the main product select element */
	var productSelect = document.querySelector('.product-form form input[name="id"]');
	if(!productSelect){ log('Could not find the main select element'); return }

	/* create a message box */
	var shippingMessage = document.createElement('p');
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');
	var shippingZip = document.createElement('input');
	var currentProvince = '';

	var cepRanges = {
		'Acre': [{ start: 69900000, end: 69999999 }],
		'Alagoas': [{ start: 57000000, end: 57999999 }],
		'Amapá': [{ start: 68900000, end: 68999999 }],
		'Amazonas': [
			{ start: 69000000, end: 69299999 },
			{ start: 69400000, end: 69899999 }
		],
		'Bahia': [{ start: 40000000, end: 48999999 }],
		'Ceará': [{ start: 60000000, end: 63999999 }],
		'Distrito Federal': [
			{ start: 70000000, end: 72799999 },
			{ start: 73000000, end: 73699999 }
		],
		'Espírito Santo': [{ start: 29000000, end: 29999999 }],
		'Goiás': [
			{ start: 72800000, end: 72999999 },
			{ start: 73700000, end: 76799999 }
		],
		'Maranhão': [{ start: 65000000, end: 65999999 }],
		'Mato Grosso': [{ start: 78000000, end: 78899999 }],
		'Mato Grosso do Sul': [{ start: 79000000, end: 79999999 }],
		'Minas Gerais': [{ start: 30000000, end: 39999999 }],
		'Pará': [{ start: 66000000, end: 68899999 }],
		'Paraíba': [{ start: 58000000, end: 58999999 }],
		'Paraná': [{ start: 80000000, end: 87999999 }],
		'Pernambuco': [{ start: 50000000, end: 56999999 }],
		'Piauí': [{ start: 64000000, end: 64999999 }],
		'Rio de Janeiro': [{ start: 20000000, end: 28999999 }],
		'Rio Grande do Norte': [{ start: 59000000, end: 59999999 }],
		'Rio Grande do Sul': [{ start: 90000000, end: 99999999 }],
		'Rondônia': [{ start: 76800000, end: 76999999 }],
		'Roraima': [{ start: 69300000, end: 69399999 }],
		'Santa Catarina': [{ start: 88000000, end: 89999999 }],
		'São Paulo': [{ start: parseInt('01000000', 10), end: 19999999 }],
		'Sergipe': [{ start: 49000000, end: 49999999 }],
		'Tocantins': [{ start: 77000000, end: 77999999 }]
	};

	var buscarEstadoPorCEP = function(cep) {
		cep = cep.replace(/\D/g, '');
		
		if (cep.length !== 8) {
			currentProvince = '';
			return '';
		}

		var cepNumero = parseInt(cep, 10);

		for (var estado in cepRanges) {
			if (cepRanges.hasOwnProperty(estado)) {
				var ranges = cepRanges[estado];
				for (var i = 0; i < ranges.length; i++) {
					if (cepNumero >= ranges[i].start && cepNumero <= ranges[i].end) {
						currentProvince = estado;
						log('Estado encontrado: ' + estado + ' (CEP: ' + cep + ')');
						return estado;
					}
				}
			}
		}

		currentProvince = '';
		log('CEP não encontrado em nenhum range: ' + cep);
		return '';
	};

	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	var initFields = function(){

		/* create the country picker */
		var countries = ['Brazil'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i===0));
		};
		shippingCountry.name = 'shipping_address[country]';

		/* create the province state picker */
		shippingProvince.name = 'shipping_address[province]';

		/* create the zip / postcode field */
		shippingZip.type = 'text';
		shippingZip.name = 'shipping_address[zip]';
		shippingZip.value = '';
		shippingZip.placeholder = 'Digite seu CEP';
		
		shippingZip.addEventListener('blur', function() {
			if (shippingZip.value.trim().length > 0) {
				buscarEstadoPorCEP(shippingZip.value);
			}
		});
		
		var cepTimeout;
		shippingZip.addEventListener('input', function() {
			clearTimeout(cepTimeout);
			cepTimeout = setTimeout(function() {
				var cepLimpo = shippingZip.value.replace(/\D/g, '');
				if (cepLimpo.length === 8) {
					buscarEstadoPorCEP(shippingZip.value);
				}
			}, 500);
		});

		/* create a wrapper for the fields */
		var shippingCalcWrapper = document.createElement('div');
		shippingCalcWrapper.className = 'shipping-calc-wrapper';

		/* create a link if don't know the Zip code */
		var shippingCalcUnknownZip = document.createElement('a');
		shippingCalcUnknownZip.className = 'link';
		shippingCalcUnknownZip.setAttribute('href', 'https://buscacepinter.correios.com.br/app/endereco/index.php');
		shippingCalcUnknownZip.setAttribute('target', '_blank');
		shippingCalcUnknownZip.innerText = 'Não sei o meu CEP';

		/* create a title */
		var shippingCalcTitle = document.createElement('h3');
		shippingCalcTitle.innerHTML = 'Entrega';

		/* create a subtitle */
		var shippingCalcSubtitle = document.createElement('p');
		shippingCalcSubtitle.className = 'subtitle';
		shippingCalcSubtitle.innerHTML = 'Consulte o prazo e valor do frete';

		/* create a get rates button */
		var shippingCalcButton = document.createElement('button');
		shippingCalcButton.innerText = 'Calcular';
		shippingCalcButton.className = 'button shippingCalcButton';
		shippingCalcButton.onclick=function(){
			var vid = productSelect.value;
			if(!vid || vid === '' || isNaN(parseInt(vid))) {
				shippingMessage.innerHTML = '<p>Selecione um tamanho/cor antes de calcular o frete.</p>';
				return false;
			}
			if(shippingZip.value != ''){
				shippingCalcButton.innerText = 'Calculando...';
				shippingCalcButton.className += ' disabled';
			}
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();

			/* if not found, make a new temp cookie */
			if(!cartCookie){ 
				log('no cookie found');
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			}else{
				log('cookie found');
			}

			/* if found but has a weird length, bail */
			if(cartCookie.length < 32){ log('cart ID not valid');return }

			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
			log(getCookie('cart'));

			getRates(parseInt(productSelect.value));
			return false;
		};

		/* create some labels for the fields */
		var labelNames = ['CEP'];
		var labels = [];
		for (var i = 0; i < labelNames.length; i++) {
			var label = document.createElement('label');
			label.innerText = labelNames[i];
			labels.push(label);
		};

		shippingCalcWrapper.appendChild(shippingCalcTitle);
		shippingCalcWrapper.appendChild(shippingCalcSubtitle);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingCountry);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingProvince);
		// shippingCalcWrapper.appendChild(labels[1]);
		shippingCalcWrapper.appendChild(shippingZip);
		shippingCalcWrapper.appendChild(shippingCalcButton);
		//shippingCalcWrapper.appendChild(shippingCalcUnknownZip);
		shippingCalcWrapper.appendChild(shippingMessage);

		/* add to the page */
		productSection.appendChild(shippingCalcWrapper);

	};

	/* A console logging function */
	function log (a){
		if(!debug){ return }

	};

	/* get cookie by name */
	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split('; '+name+'=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};

	/* update the cart cookie value */
	var updateCartCookie = function(a) {
		log('changing cart cookie value to: '+a);
		var date = new Date();
		date.setTime(date.getTime()+(14*86400000));
		var expires = '; expires='+date.toGMTString();
		document.cookie = 'cart='+a+expires+'; path=/';
	};

	/* reset the cart cookie value */
	var resetCartCookie = function(){
		updateCartCookie(cartCookie);
		log(getCookie('cart'));
	};

	/* get the rates */
	var getRates = function(variantId){
		/* add whatever sanity checks you need in addition to the one below */
		if(typeof variantId === 'undefined' || isNaN(variantId) || variantId <= 0) {
			shippingMessage.innerHTML = '<p>Selecione uma variante válida antes de calcular o frete.</p>';
			document.querySelector('.shippingCalcButton').innerText = 'Calcular';
			document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
			return;
		}

		/* the main quantity element */
		var productQuantity = document.querySelector('.quantity__input');

		var quantity = productQuantity ? parseInt(productQuantity.value):1;
		var addData = {
			'id':variantId,
			'quantity':quantity
		};

		fetch('/cart/add.js', {
			body: JSON.stringify(addData),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
			method: 'POST'
		}).then(function(response) {
			return response.json();
		}).then(function(json) {
			/* Verificar se a Shopify retornou erro no add.js */
			if (json && json.status && json.status >= 400) {
				shippingMessage.innerHTML = '<p>Não foi possível calcular o frete. Verifique se o produto está disponível.</p>';
				document.querySelector('.shippingCalcButton').innerText = 'Calcular';
				document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
				resetCartCookie();
				return;
			}

			if (!currentProvince) {
				buscarEstadoPorCEP(shippingZip.value);
				
				if (!currentProvince) {
					shippingMessage.innerHTML = '<p>CEP inválido ou não encontrado. Por favor, verifique o CEP digitado.</p>';
					document.querySelector('.shippingCalcButton').innerText = 'Calcular';
					document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
					resetCartCookie();
					return;
				}
			}

			fetch('/cart/shipping_rates.json?' + new URLSearchParams({
				'shipping_address[country]':shippingCountry.value,
				'shipping_address[province]':currentProvince,
				'shipping_address[zip]':shippingZip.value
			})).then(function(response) {
				return response.json();
			}).then(function(result) {
				if(result.shipping_rates && result.shipping_rates.length){
					let messageHtml = '<ul>'
					for (let i = 0; i < result.shipping_rates.length; i++) {
						const element = result.shipping_rates[i];
						let deliveryInfo = '';
						
						if (element.name === 'Local Delivery' || element.code === 'Local Delivery') {
							deliveryInfo = element.description ? `<span>${element.description}</span>` : '';
						} else if (element.delivery_days && Array.isArray(element.delivery_days) && element.delivery_days.length > 0) {
							if (element.delivery_days[0] == 1) {
								deliveryInfo = '<span>1 dia útil</span>'
							} else {
								deliveryInfo = `<span>${element.delivery_days[0]} dias úteis</span>`
							}
						}
						messageHtml += `
						<li>
							${element.name === 'Local Delivery' ? 'Entrega local' : element.name } por <b>R$ ${element.price.replace('.', ',')}</b>
							<br>
							${deliveryInfo}
						</li>
						`;
					}
					messageHtml += '</ul>';
					shippingMessage.innerHTML = messageHtml;
					document.querySelector('.shippingCalcButton').innerText = 'Calcular';
					document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
				}
				resetCartCookie()
			}).catch(function() {
				resetCartCookie();
				shippingMessage.innerHTML = '';
				document.querySelector('.shippingCalcButton').innerText = 'Calcular';
				document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
			})
		}).catch(function(err) {
			/* uh oh, we have error. */
			console.error(err);
			resetCartCookie()
		});

	};

	initFields();
})()